<template>
  <a-modal
    v-model="visible"
    title="萤石序列号设置"
    :width="800"
    @ok="handleYsSnOk"
    :destroyOnClose="true"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <!-- 安装单 -->
    <template v-if="ysOrderType == 1">
      <!-- SN码输入区域 -->
      <div class="form-item">
        <span class="form-label">整锁/面板SN码：</span>
        <a-input v-model="ysAzForm.sn" placeholder="请输入整锁/面板SN码" style="width: 300px; margin-right: 15px;" />
        <a-button :disabled="snStorage.sn == ysAzForm.sn" type="primary" @click="handleInitYsSn">
          确认
        </a-button>
      </div>

      <!-- 产品类型显示 -->
      <div v-if="currentSnType">
        <div v-if="currentDeviceInfo.name" class="form-item">
          <span class="form-label">产品名称：</span>
          <span class="form-value">{{ currentDeviceInfo.name }}</span>
        </div>
        <div v-if="currentDeviceInfo.model" class="form-item">
          <span class="form-label">产品型号：</span>
          <span class="form-value">{{ currentDeviceInfo.model }}</span>
        </div>
        <div class="form-item">
          <span class="form-label">产品类型：</span>
          <span class="form-value">
            <a-tag color="blue">
              {{ currentSnType == 1 ? '整锁' :
                currentSnType == 2 ? '配件' :
                currentSnType == 3 ? '锁体' :
                currentSnType == 4 ? '面板' : '未知' }}
            </a-tag>
          </span>
        </div>
      </div>

      <!-- 整锁逻辑 -->
      <div v-if="currentSnType == 1">
        <div class="form-item">
          <span class="form-label">是否可安装：</span>
          <a-radio-group v-model="ysAzForm.status" @change="snStatusChange">
            <a-radio :value="'1'">是</a-radio>
            <a-radio :value="'2'">否</a-radio>
          </a-radio-group>
          <span class="form-tips" v-if="ysAzForm.status == '2'">（请师傅务必联系微信派单客服进行处理！）</span>
        </div>
      </div>

      <!-- 面板逻辑 -->
      <div v-if="currentSnType == 4">
        <div class="form-item" style="align-items: flex-start;">
          <span class="form-label">锁体信息：</span>
          <div class="form-item-v">
            <a-radio-group v-if="skuIsLimited == 0" v-model="lockUseType" @change="lockUseTypeChange">
              <a-radio :value="'1'">SN码</a-radio>
              <a-radio :value="'2'">选择</a-radio>
            </a-radio-group>
            <div v-show="lockUseType == '1'">
              <a-input v-model="ysAzForm.lockSn" placeholder="请输入锁体SN码" style="width: 300px; margin-right: 15px;" />
              <a-button
                :disabled="snStorage.lockSn == ysAzForm.lockSn"
                type="primary"
                @click="handleYsLockSn">确认</a-button>
            </div>
            <div v-show="lockUseType == '2'">
              <a-select
                style="width: 300px;"
                v-model="ysAzForm.lockSkuNo"
                :allowClear="true"
                @change="handleLockSnChange">
                <a-select-option v-for="item in lockList" :key="item.skuNo" :value="item.skuNo">
                  {{ item.skuName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>

        <div class="form-item">
          <span class="form-label">是否可安装：</span>
          <a-radio-group v-model="ysAzForm.status" @change="handleMergedStatusChange">
            <a-radio :value="'1'">是</a-radio>
            <a-radio :value="'2'">否</a-radio>
          </a-radio-group>
          <span class="form-tips" v-if="ysAzForm.status == '2'">（请师傅务必联系微信派单客服进行处理！）</span>
        </div>
      </div>
    </template>
    <!-- 维修单 -->
    <template v-else-if="ysOrderType == 2">
      <!-- SN码输入区域 -->
      <div class="form-item">
        <div class="form-label required">整锁/面板SN码：</div>
        <a-input v-model="ysWxForm.serialNo" placeholder="请输入整锁/面板SN码" style="width: 300px; margin-right: 15px;" />
        <a-button :disabled="snWxStorage.serialNo == ysWxForm.serialNo" type="primary" @click="handleInitYsWxSn">
          确认
        </a-button>
      </div>
      <div v-if="currentDeviceInfo.sn" style="text-align: center;padding: 0 0 20px 0;color: brown;">
        <div>质保到期时间：{{ currentDeviceInfo.warrantyTime }}</div>
        <div>保修状态：{{ currentDeviceInfo.validWarranty == 1 ? '保内' : '保外' }}</div>
      </div>
      <!-- 维修对象单号 -->
      <div class="form-item">
        <span class="form-label required">维修对象单号：</span>
        <a-input v-model="ysWxForm.targetNo" placeholder="请输入维修对象单号" style="width: 300px; margin-right: 15px;" />
      </div>
      <!-- 整锁逻辑 -->
      <template v-if="currentSnType == 1">
        <div class="form-item">
          <span class="form-label required">是否替换：</span>
          <a-radio-group v-model="ysStChangeStatus" @change="ysStWxChange">
            <a-radio :value="1">不替换</a-radio>
            <a-radio :value="2">替换整锁</a-radio>
            <a-radio :value="3">替换面板+锁体</a-radio>
          </a-radio-group>
        </div>
        <!-- 替换整锁SN码 -->
        <div class="form-item" v-if="ysStChangeStatus == 2">
          <span class="form-label required">替换整锁SN码：</span>
          <a-input v-model="ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" placeholder="请输入替换整锁SN码" style="width: 300px; margin-right: 15px;" />
          <a-button :disabled="snWxStorage.panelSn == ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" type="primary" @click="handleChangeYsWxSnQr(1)">
            确认
          </a-button>
        </div>
        <!-- 替换面板+锁体 -->
        <!-- 面板 -->
        <div class="form-item" v-if="ysStChangeStatus == 3">
          <span class="form-label required">替换面板SN码：</span>
          <a-input v-model="ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" placeholder="请输入替换面板SN码" style="width: 300px; margin-right: 15px;" />
          <a-button :disabled="snWxStorage.panelSn == ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" type="primary" @click="handleChangeYsWxSnQr(2, true)">
            确认
          </a-button>
        </div>
        <!-- 锁体 -->
        <div class="form-item" style="align-items: flex-start;" v-if="ysStChangeStatus == 3">
          <span class="form-label required">替换锁体SN码：</span>
          <div class="form-item-v">
            <a-radio-group v-if="skuIsLimited == 0" v-model="lockChangeUseType" @change="lockChangeUseTypeWxChange">
              <a-radio :value="'1'">SN码</a-radio>
              <a-radio :value="'2'">选择</a-radio>
            </a-radio-group>
            <div v-show="lockChangeUseType == '1'">
              <a-input v-model="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn" :disabled="ysStChangeStatus == 3 && !ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" placeholder="请输入替换锁体SN码" style="width: 300px; margin-right: 15px;" />
              <a-button :disabled="snWxStorage.replaceLockBodyInfoLockSn == ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn" type="primary" @click="handleChangeYsWxSnQr(3)">
                确认
              </a-button>
            </div>
            <div v-show="lockChangeUseType == '2'">
              <a-select
                style="width: 300px;"
                v-model="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo"
                :allowClear="true"
                @change="handleWxLockReplaceSnChange">
                <a-select-option v-for="item in lockList" :key="item.skuNo" :value="item.skuNo">
                  {{ item.skuName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-tips" style="margin-top: 34px;" v-if="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo">{{ ysWxForm.lockBodyInfo.replaceLockBodyInfo.isEZLock == 1 ? '萤石锁体' : '非萤石锁体' }}</div>
        </div>
      </template>

      <!-- 面板逻辑 -->
      <div v-if="currentSnType == 4">
        <!-- 原锁体 -->
        <div class="form-item" style="align-items: flex-start;">
          <span class="form-label required">锁体SN码：</span>
          <div class="form-item-v">
            <a-radio-group v-if="skuIsLimited == 0" v-model="lockUseType" @change="lockUseTypeWxChange">
              <a-radio :value="'1'">录入</a-radio>
              <a-radio :value="'2'">选择</a-radio>
            </a-radio-group>
            <div v-show="lockUseType == '1'">
              <a-input v-model="ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn" placeholder="请输入锁体SN码" style="width: 300px; margin-right: 15px;" />
              <a-button
                :disabled="snWxStorage.currentLockBodyInfoLockSn == ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn"
                type="primary"
                @click="handleYsLockWxSn">确认</a-button>
            </div>
            <div v-show="lockUseType == '2'">
              <a-select
                style="width: 300px;"
                v-model="ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuNo"
                :allowClear="true"
                @change="handleLockWxSnChange">
                <a-select-option v-for="item in lockList" :key="item.skuNo" :value="item.skuNo">
                  {{ item.skuName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-tips" style="margin-top: 34px;" v-if="ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuNo">{{ ysWxForm.lockBodyInfo.currentLockBodyInfo.isEZLock == 1 ? '萤石锁体' : '非萤石锁体' }}</div>
        </div>
        <!-- 替换选项 -->
        <div class="form-item">
          <span class="form-label required">是否替换：</span>
          <a-radio-group v-model="ysMbChangeStatus" @change="ysStWxChange">
            <a-radio :value="1">不替换</a-radio>
            <a-radio :value="2">替换整锁</a-radio>
            <a-radio :value="3">替换面板</a-radio>
            <a-radio :value="4">替换锁体</a-radio>
            <a-radio :value="5">替换面板+锁体</a-radio>
          </a-radio-group>
        </div>
        <!-- 替换整锁SN码 -->
        <div class="form-item" v-if="ysMbChangeStatus == 2">
          <span class="form-label required">替换整锁SN码：</span>
          <a-input v-model="ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" placeholder="请输入替换整锁SN码" style="width: 300px; margin-right: 15px;" />
          <a-button :disabled="snWxStorage.panelSn == ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" type="primary" @click="handleChangeYsWxSnQr(1)">
            确认
          </a-button>
        </div>
        <!-- 替换面板 -->
        <div v-if="ysMbChangeStatus == 3 || ysMbChangeStatus == 5" class="form-item">
          <span class="form-label required">替换面板SN码：</span>
          <a-input v-model="ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" placeholder="请输入替换面板SN码" style="width: 300px; margin-right: 15px;" />
          <a-button :disabled="snWxStorage.panelSn == ysWxForm.lockBodyInfo.replacePanelInfo.panelSn" type="primary" @click="handleChangeYsWxSnQr(2)">
            确认
          </a-button>
        </div>
        <!-- 替换锁体 -->
        <div v-if="ysMbChangeStatus == 4 || ysMbChangeStatus == 5" class="form-item" style="align-items: flex-start;">
          <span class="form-label required">替换锁体SN码：</span>
          <div class="form-item-v">
            <a-radio-group v-if="skuIsLimited == 0" v-model="lockChangeUseType" @change="lockChangeUseTypeWxChange">
              <a-radio :value="'1'">录入</a-radio>
              <a-radio :value="'2'">选择</a-radio>
            </a-radio-group>
            <div v-show="lockChangeUseType == '1'">
              <a-input
                v-model="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn"
                placeholder="请输入替换锁体SN码"
                style="width: 300px; margin-right: 15px;" />
              <a-button
                :disabled="snWxStorage.replaceLockBodyInfoLockSn == ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn"
                type="primary"
                @click="handleChangeYsWxSnQr(3)">确认</a-button>
            </div>
            <div v-show="lockChangeUseType == '2'">
              <a-select
                style="width: 300px;"
                v-model="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo"
                :allowClear="true"
                @change="handleWxLockReplaceSnChange">
                <a-select-option v-for="item in lockList" :key="item.skuNo" :value="item.skuNo">
                  {{ item.skuName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="form-tips" style="margin-top: 34px;" v-if="ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo">{{ ysWxForm.lockBodyInfo.replaceLockBodyInfo.isEZLock == 1 ? '萤石锁体' : '非萤石锁体' }}</div>
        </div>
      </div>
      <!-- 维修凭证 -->
      <div class="form-item" v-if="showVoucherContentUpload">
        <span class="form-label required">维修凭证：</span>
        <a-upload
          :multiple="false"
          name="file"
          list-type="picture-card"
          :file-list="voucherContentFileList"
          style="flex: 1"
          :headers="headers"
          @preview="handlePreview"
          :action="currencyuploadUrl"
          @change="voucherContenthandleChange">
          <span>
            <a-icon type="upload" />
            <div class="ant-upload-text">维修凭证</div>
          </span>
        </a-upload>
      </div>
      <!-- 故障原因 -->
      <div class="form-item">
        <span class="form-label required">故障原因：</span>
        <a-select style="width: 300px;" v-model="ysWxForm.reasonType" :allowClear="true" @change="handleReasonChange($event, true)">
          <a-select-option v-for="item in ysWxReasonList" :key="item.reasonType" :value="item.reasonType">
            {{ item.reasonTitle }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 原因1 -->
      <div class="form-item" v-if="detailsReasonList.title">
        <span class="form-label required">{{ detailsReasonList.title }}：</span>
        <a-select style="width: 300px;" v-model="reasonValue1" :mode="detailsReasonList.list.length && detailsReasonList.list[0].addType == 'specificReasonType' ? 'multiple' : 'default'" :allowClear="true" @change="handleProgramChange('detailsReasonList', $event)">
          <a-select-option v-for="item in detailsReasonList.list" :key="item.type" :value="item.type">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 原因2 -->
      <div class="form-item" v-if="subReasonList.title">
        <span class="form-label required">{{ subReasonList.title }}：</span>
        <a-select style="width: 300px;" v-model="reasonValue2" :mode="subReasonList.list.length && subReasonList.list[0].addType == 'specificReasonType' ? 'multiple' : 'default'" :allowClear="true" @change="handleProgramChange('subReasonList', $event)">
          <a-select-option v-for="item in subReasonList.list" :key="item.type" :value="item.type">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 多级原因 -->
      <div class="form-item" v-if="goodsFaultList.length > 0">
        <span class="form-label required">多级原因：</span>
        <a-tree-select
          v-model="goodsFaultValue"
          style="width: 300px"
          treeCheckable
          size="default"
          multiple
          tree-default-expand-all
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="goodsFaultList" />
      </div>
      <!-- 维修项目 -->
      <div class="form-item">
        <span class="form-label required">维修项目：</span>
        <a-select
          style="width: 300px;"
          :dropdownStyle="{ width:'500px' }"
          :dropdownMatchSelectWidth="false"
          :maxTagCount="3"
          mode="multiple"
          v-model="repairItemsValue"
          :allowClear="true">
          <a-select-option v-for="item in useYsWxTargetItems" :key="item.no" :value="item.no">
            {{ `${item.name} (${item.no})` }}
          </a-select-option>
        </a-select>
      </div>
    </template>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  determineIsEzvizSn,
  judgeOrderType,
  getRepairReport,
  getRepairOptions,
  getPartsListInfo,
  determineIsForceControl,
  checkEzvizSn,
  getYsSn,
  verifyYsSn,
  getEzvizOrderDetail,
  verifyRepairOptions
} from '@/api/order/editorder'

export default {
  name: 'EzvizSnModal',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    },
    reslist: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      headers: {
        Authorization: Vue.ls.get(ACCESS_TOKEN)
      },
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=order',
      workOrderNo: '',
      ysOrderType: 1, // 1 安装单 2 维修单
      ysAzForm: {
        sn: '',
        skuNo: '',
        skuName: '',
        replaceSn: '',
        replaceSkuNo: '',
        replaceSkuName: '',
        lockSn: '',
        lockSkuNo: '',
        lockSkuName: '',
        lockReplaceSn: '',
        lockReplaceSkuNo: '',
        lockReplaceSkuName: '',
        lockStatus: '',
        status: '',
        snType: ''
      },
      ysWxForm: {
        workOrderNo: '',
        targetNo: '',
        serialNo: '',
        voucherType: '',
        voucherContent: '',
        reasonType: '',
        programType: '',
        specificReasonItems: [],
        repairItems: [],
        lockBodyInfo: {
          currentLockBodyInfo: {
            lockSkuNo: '',
            lockSkuName: '',
            lockSn: '',
            isEZLock: 1
          },
          replaceLockBodyInfo: {
            lockSkuNo: '',
            lockSkuName: '',
            lockSn: '',
            isEZLock: 1
          },
          replacePanelInfo: {
            panelSkuNo: '',
            panelSkuName: '',
            panelSn: ''
          }
        },
        goodsFaultList: []
      },
      snStorage: {
        sn: null,
        replaceSn: null,
        lockSn: null,
        lockReplaceSn: null
      },
      snWxStorage: {
        serialNo: null,
        currentLockBodyInfoLockSn: null,
        replaceLockBodyInfoLockSn: null,
        panelSn: null
      },
      currentSnType: null,
      currentDeviceInfo: {},
      ysStChangeStatus: 1,
      ysMbChangeStatus: 1,
      ysMbChangeStStatus: 1,
      skuIsLimited: 0,
      lockList: [],
      lockUseType: '1',
      lockChangeUseType: '1',
      showVoucherContentUpload: false,
      voucherContentFileList: [],
      ysWxReasonList: [],
      ysWxTargetItems: [],
      detailsReasonList: {
        title: '',
        list: [],
        desc: ''
      },
      subReasonList: {
        title: '',
        list: [],
        desc: ''
      },
      reasonValue1: '',
      reasonValue2: '',
      goodsFaultList: [],
      goodsFaultValue: [],
      repairItemsValue: [],
      reportNo: ''
    }
  },
  computed: {
    useYsWxTargetItems () {
      return this.ysWxTargetItems
    }
  },
  watch: {
    goodsFaultValue (val) {
      this.convertGoodsFaultValue(val)
    },
    repairItemsValue (val) {
      this.ysWxForm.repairItems = this.ysWxTargetItems.filter(item => val.includes(item.no))
    }
  },
  methods: {
    // 打开弹窗
    async open () {
      this.resetYsForm()
      await this.getYsWorkOrderNo()
      await this.judgeOrderType()
      this.visible = true
    },
    // 关闭弹窗
    handleCancel () {
      this.visible = false
      this.$emit('close')
    },
    // 查萤石原始单号
    getYsWorkOrderNo () {
      return new Promise((resolve, reject) => {
        determineIsEzvizSn({ orderId: this.orderId }).then(res => {
          this.workOrderNo = res.data.workOrderNo
          resolve()
        }).catch(err => { reject(err) })
      })
    },
    // 判断安装单还是维修单
    judgeOrderType () {
      return new Promise((resolve, reject) => {
        judgeOrderType({ orderId: this.orderId }).then(async res => {
          if (res.code == 0) {
            this.ysOrderType = res.data // 1 安装单 2 维修单
            if (this.ysOrderType == '2') {
              /* 初始化故障选项相关 */
              const optionsMap = await this.getRepairOptions()
              if (optionsMap && optionsMap.optionsList) {
                this.ysWxReasonList = optionsMap.optionsList
              }
              if (optionsMap && optionsMap.targetItems) {
                this.ysWxTargetItems = optionsMap.targetItems
              }
              /* 初始化表单相关 */
              const ezvizOrderDetail = await this.getEzvizOrderDetail() // 获取维修单详情
              if (ezvizOrderDetail.reportNo) {
                /* 走修改逻辑... */
                this.reportNo = ezvizOrderDetail.reportNo
                this.getReportDetails()
              } else {
                /* 初始化原设备SN */
                if (ezvizOrderDetail.items.length && ezvizOrderDetail.items[0].sn) {
                  this.initYsWxSn(ezvizOrderDetail.items[0].sn)
                }
              }
            } else {
              // 获取安装单详情，回显安装单表单数据
              this.getYsSn()
            }
          } else {
            this.$message.error(res.msg)
          }
          resolve()
        }).catch(err => { reject(err) })
      })
    },
    /* 获取维修单详情 */
    getReportDetails () {
      if (!this.reportNo) return
      getRepairReport({ reportNo: this.reportNo }).then(async res => {
        this.ysWxForm = res.data.repairWorkOrder
        await this.initYsWxSn(this.ysWxForm.serialNo)

        this.ysWxForm.serialNo && (this.snWxStorage.serialNo = this.ysWxForm.serialNo)
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn && (this.snWxStorage.currentLockBodyInfoLockSn = this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn)
        this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn && (this.snWxStorage.replaceLockBodyInfoLockSn = this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn)
        this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn && (this.snWxStorage.panelSn = this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn)

        this.handleReasonChange(this.ysWxForm.reasonType, false)
        if (this.ysWxForm.specificReasonItems.length) {
          this.reasonValue1 = this.ysWxForm.specificReasonItems.map(s => s.type)
          this.reasonValue2 = this.ysWxForm.programType
        } else {
          this.reasonValue1 = this.ysWxForm.reasonType
        }

        this.repairItemsValue = this.ysWxForm.repairItems.map(s => s.no)

        this.voucherContentFileList = [{
          url: this.ysWxForm.voucherContent,
          name: '',
          uid: new Date().getTime()
        }]

        if (res.data.otherString) {
          const { ysStChangeStatus, lockUseType, ysMbChangeStatus, lockChangeUseType } = res.data.otherString
          this.ysStChangeStatus = ysStChangeStatus
          this.lockUseType = lockUseType
          this.ysMbChangeStatus = ysMbChangeStatus
          this.lockChangeUseType = lockChangeUseType
        }

        if (this.ysOrderType == 2 && this.currentSnType == 1 && this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn) {
          const { skuIsLimited } = await this.determineIsForceControl({
            workOrderNo: this.workOrderNo,
            sn: this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn,
            snType: 0,
            scenarioType: 2
          })
          this.skuIsLimited = skuIsLimited
          if (this.skuIsLimited == 0) {
            const { list } = await this.getPartsListInfo()
            this.lockList = list
          }
        }

        const currentReason = this.ysWxReasonList.find(s => s.reasonType == this.ysWxForm.reasonType)
        if (currentReason && currentReason.reasonList) {
          this.detailsReasonList = {
            title: currentReason.reasonList.title,
            list: currentReason.reasonList.list,
            desc: currentReason.reasonList.desc
          }
          if (currentReason.reasonList.subList) {
            this.subReasonList = currentReason.reasonList.subList
          }
        }

        // 从goodsFaultList反推出goodsFaultValue
        if (this.ysWxForm.goodsFaultList && this.ysWxForm.goodsFaultList.length > 0) {
          this.goodsFaultValue = this.ysWxForm.goodsFaultList.map(item => {
            // 取idList的最后一个元素，即选中项的id
            if (item.idList && item.idList.length > 0) {
              return Number(item.idList[item.idList.length - 1])
            }
            return null
          }).filter(id => id !== null)
        } else {
          this.goodsFaultValue = []
        }
      })
    },
    // 获取维修工单可选配件列表
    getRepairOptions () {
      return new Promise((resolve, reject) => {
        getRepairOptions({ workOrderNo: this.workOrderNo }).then(res => {
          resolve(res.data)
        }).catch(err => reject(err))
      })
    },
    // 获取萤石锁体配件列表
    getPartsListInfo () {
      return new Promise((resolve, reject) => {
        const skuNo = this.ysOrderType == 1 ? this.ysAzForm.skuNo : this.ysWxForm.targetNo
        getPartsListInfo({ skuNo }).then(res => {
          if (res.code == 0) {
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(err => { reject(err) })
      })
    },
    // 查询萤石订单是否需要管控
    determineIsForceControl ({ workOrderNo, sn, snType }) {
      return new Promise((resolve, reject) => {
        const data = {
          workOrderNo,
          sn,
          snType,
          scenarioType: 2
        }
        determineIsForceControl(data).then(res => {
          if (res.code == 0) {
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(err => { reject(err) })
      })
    },
    /* 上传凭证 */
    voucherContenthandleChange (info) {
      this.$nextTick(() => {
        this.voucherContentFileList = [info.file]
      })
      if (info.file.status == 'removed') {
        this.$nextTick(() => {
          this.ysWxForm.voucherContent = ''
          this.voucherContentFileList = []
        })
      }
      if (info.file.status == 'done') {
        if (info.file.response.code == 0) {
          let list = {}
          list.url = info.file.response.url
          list.uid = info.fileList[0].uid
          list.name = info.fileList[0].name
          list = JSON.stringify(list)
          this.voucherContentFileList.push(list)
          this.ysWxForm.voucherContent = info.file.response.pathfileName
        }
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status == 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    /* 故障原因更改（更新维修方案类型选项） */
    handleReasonChange (e, resetFlag) {
      const currentReason = this.ysWxReasonList.find(s => s.reasonType == e)
      if (currentReason && currentReason.reasonList) {
        this.detailsReasonList = {
          title: currentReason.reasonList.title,
          list: currentReason.reasonList.list,
          desc: currentReason.reasonList.desc
        }
        if (currentReason.reasonList.subList) {
          this.subReasonList = currentReason.reasonList.subList
        } else {
          this.subReasonList = {
            title: '',
            list: [],
            desc: ''
          }
        }
        if (currentReason.reasonList.goodsFaultList) {
          const convertData = (data) => {
            return data.map(item => {
              return {
                title: item.desc,
                key: item.id,
                value: item.id,
                children: item.children ? convertData(item.children) : []
              }
            })
          }
          this.goodsFaultList = convertData(currentReason.reasonList.goodsFaultList)
        } else {
          this.goodsFaultList = []
        }
      } else {
        this.detailsReasonList = {
          title: '',
          list: [],
          desc: ''
        }
        this.subReasonList = {
          title: '',
          list: [],
          desc: ''
        }
      }
      if (resetFlag) {
        this.ysWxForm.specificReasonItems = []
        this.goodsFaultValue = []
        this.ysWxForm.programType = ''
        this.reasonValue1 = this.detailsReasonList.list.length && this.detailsReasonList.list[0].addType == 'specificReasonType' ? [] : ''
        this.reasonValue2 = this.subReasonList.list.length && this.subReasonList.list[0].addType == 'specificReasonType' ? [] : ''
      }
    },
    /* 维修方案更改 */
    handleProgramChange (key, e) {
      const currentPrograms = this[key].list.find(s => s.type == e)
      if (currentPrograms && currentPrograms.addType == 'specificReasonType') {
        this.ysWxForm.specificReasonItems = [
          {
            type: currentPrograms.type,
            content: currentPrograms.title
          }
        ]
      }
      if (currentPrograms && currentPrograms.addType == 'programType') {
        this.ysWxForm.programType = e
      }
    },
    // 将选中的goodsFaultValue转换为ysWxForm.goodsFaultList需要的格式
    convertGoodsFaultValue (selectedIds) {
      let originalData = []
      const reasonItem = this.ysWxReasonList.find(s => s.reasonType == this.ysWxForm.reasonType)
      if (reasonItem && reasonItem.reasonList && reasonItem.reasonList.goodsFaultList) {
        originalData = reasonItem.reasonList.goodsFaultList
      }

      const findPath = (data, targetId, currentPath = []) => {
        for (const item of data) {
          const newPath = [...currentPath, item]
          if (item.id === targetId) {
            return newPath
          }
          if (item.children && item.children.length > 0) {
            const result = findPath(item.children, targetId, newPath)
            if (result) {
              return result
            }
          }
        }
        return null
      }

      const result = selectedIds.map(id => {
        const path = findPath(originalData, id)
        if (path) {
          return {
            idList: path.map(item => item.id.toString()),
            descList: path.map(item => item.desc)
          }
        }
        return null
      }).filter(item => item)

      this.ysWxForm.goodsFaultList = result
    },
    snStatusChange (e) {
      this.ysAzForm.status = e.target.value
      this.ysAzForm.lockStatus = e.target.value
    },
    handleMergedStatusChange (e) {
      this.ysAzForm.status = e.target.value
      this.ysAzForm.lockStatus = e.target.value
    },
    checkEzvizSn (sn, snType, scenarioType) {
      return new Promise((resolve, reject) => {
        checkEzvizSn({
          workOrderNo: this.workOrderNo,
          sn,
          snType,
          scenarioType
        }).then(res => {
          if (res.code == 0) {
            resolve(res.data)
          } else if (res.code == 500) {
            reject(res.msg)
          }
        })
      })
    },
    resetYsForm () {
      this.ysAzForm = {
        sn: '',
        skuNo: '',
        skuName: '',
        replaceSn: '',
        replaceSkuNo: '',
        replaceSkuName: '',
        lockSn: '',
        lockSkuNo: '',
        lockSkuName: '',
        lockReplaceSn: '',
        lockReplaceSkuNo: '',
        lockReplaceSkuName: '',
        lockStatus: '',
        status: '',
        snType: ''
      }
      this.snStorage = {
        sn: null,
        replaceSn: null,
        lockSn: null,
        lockReplaceSn: null
      }
      this.workOrderNo = ''
      this.ysOrderType = 1
      this.currentSnType = null
      this.ysMbChangeStatus = 1
      this.ysStChangeStatus = 1
      this.ysMbChangeStStatus = 1
      this.skuIsLimited = 0
      this.lockList = []
      this.lockUseType = '1'
      this.lockChangeUseType = '1'

      this.ysWxForm = {
        workOrderNo: '',
        targetNo: '',
        serialNo: '',
        voucherType: '',
        voucherContent: '',
        reasonType: '',
        programType: '',
        specificReasonItems: [],
        repairItems: [],
        lockBodyInfo: {
          currentLockBodyInfo: {
            lockSkuNo: '',
            lockSkuName: '',
            lockSn: '',
            isEZLock: 1
          },
          replaceLockBodyInfo: {
            lockSkuNo: '',
            lockSkuName: '',
            lockSn: '',
            isEZLock: 1
          },
          replacePanelInfo: {
            panelSkuNo: '',
            panelSkuName: '',
            panelSn: ''
          }
        },
        goodsFaultList: []
      }
      this.snWxStorage = {
        serialNo: null,
        currentLockBodyInfoLockSn: null,
        replaceLockBodyInfoLockSn: null,
        panelSn: null
      }
      this.currentDeviceInfo = {}
      this.showVoucherContentUpload = false
      this.voucherContentFileList = []
      this.ysWxReasonList = []
      this.detailsReasonList = { title: '', list: [], desc: '' }
      this.subReasonList = { title: '', list: [], desc: '' }
      this.reasonValue1 = ''
      this.reasonValue2 = ''
      this.goodsFaultList = []
      this.ysWxTargetItems = []
      this.goodsFaultValue = []
      this.repairItemsValue = []
      this.reportNo = ''
    },
    verifyForm () {
      if (this.ysOrderType == 1) { // 安装单
        if (!this.ysAzForm.sn) {
          this.$message.error('请输入整锁/面板SN码！')
          return false
        }
        if (!this.ysAzForm.skuNo || !this.ysAzForm.skuName) {
          this.$message.error('请点击确认按钮校验设备信息!')
          return false
        }
        for (const key in this.snStorage) {
          if ((this.snStorage[key] || this.ysAzForm[key]) && this.snStorage[key] != this.ysAzForm[key]) {
            this.$message.error('请点击确认按钮校验设备信息!')
            return false
          }
        }
      } else if (this.ysOrderType == 2) { // 维修单
        if (!this.ysWxForm.workOrderNo) {
          this.$message.error('获取订单失败！')
          return false
        }
        if (!this.ysWxForm.serialNo) {
          this.$message.error('请输入整锁/面板SN码！')
          return false
        } else if (this.ysWxForm.serialNo != this.snWxStorage.serialNo) {
          this.$message.error('请点击确认按钮校验设备信息!')
          return false
        }
        if (!this.ysWxForm.targetNo) {
          this.$message.error('请输入维修对象单号！')
          return false
        }
        if (this.currentDeviceInfo.validWarranty == 1 && !this.ysWxForm.voucherContent) {
          this.$message.error('请上传维修凭证！')
          return false
        }
        if (!this.ysWxForm.reasonType) {
          this.$message.error('请选择故障原因！')
          return false
        }
        if (!this.ysWxForm.programType) {
          this.$message.error('请选择维修方案！')
          return false
        }
        if (this.ysWxForm.repairItems.length == 0) {
          this.$message.error('请选择维修项目！')
          return false
        }
      }
      return true
    },
    // 提交
    handleYsSnOk () {
      if (!this.verifyForm()) return

      if (this.ysOrderType == 1 && this.ysAzForm.snType == 1) {
        this.ysStChangeStatus = 1
      }
      if (this.ysOrderType == 1 && this.ysAzForm.snType == 4) {
        this.ysMbChangeStatus = 1
        this.ysMbChangeStStatus = 1
      }
      if (this.ysAzForm.snType == 1 && this.ysStChangeStatus == 1) {
        this.ysAzForm.replaceSn = ''
        this.ysAzForm.replaceSkuNo = ''
        this.ysAzForm.replaceSkuName = ''
      }
      if (this.ysAzForm.snType == 4 && this.ysMbChangeStatus == 1) {
        this.ysAzForm.replaceSn = ''
        this.ysAzForm.replaceSkuNo = ''
        this.ysAzForm.replaceSkuName = ''
      }
      if (this.ysAzForm.snType == 4 && this.ysMbChangeStStatus == 1) {
        this.ysAzForm.lockReplaceSn = ''
        this.ysAzForm.lockReplaceSkuNo = ''
        this.ysAzForm.lockReplaceSkuName = ''
      }

      if (this.ysOrderType == 1) {
        console.log(this.lockUseType)
        this.ysAzForm.otherString={
          lockUseType: this.lockUseType
        }
               console.log(this.ysAzForm)

        const data = {
          workOrderNo: this.workOrderNo,
          orderId: this.orderId,
          sns: [this.ysAzForm]
        }
        verifyYsSn(data).then(res => {
          if (res.code == 0) {
            this.$emit('refresh')
            this.visible = false
          } else if (res.code == 500) {
            this.$message.error(res.msg)
          }
        })
      } else if (this.ysOrderType == 2) {
        const { currentLockBodyInfo, replaceLockBodyInfo, replacePanelInfo } = this.ysWxForm.lockBodyInfo
        const data = {
          workOrderNo: this.workOrderNo,
          orderId: this.orderId,
          otherString: {
            ysStChangeStatus: this.ysStChangeStatus,
            lockUseType: this.lockUseType,
            ysMbChangeStatus: this.ysMbChangeStatus,
            lockChangeUseType: this.lockChangeUseType
          },
          repairWorkOrder: {
            ...this.ysWxForm,
            lockBodyInfo: {
              currentLockBodyInfo: currentLockBodyInfo.lockSkuNo ? currentLockBodyInfo : null,
              replaceLockBodyInfo: replaceLockBodyInfo.lockSkuNo ? replaceLockBodyInfo : null,
              replacePanelInfo: replacePanelInfo.panelSn ? replacePanelInfo : null
            }
          },
          reportNo: this.reportNo || null
        }
        verifyRepairOptions(data).then(res => {
          if (res.code == 0) {
            this.$emit('refresh')
            this.visible = false
          } else if (res.code == 500) {
            this.$message.error(res.msg)
          }
        })
      }
    },
    getEzvizOrderDetail () {
      return new Promise((resolve, reject) => {
        getEzvizOrderDetail({ workOrderNo: this.workOrderNo }).then(res => {
          resolve(res.data)
        }).catch(err => reject(err))
      })
    },
    handleInitYsWxSn () {
      if (!this.ysWxForm.serialNo) {
        this.$message.error('请输入SN码！')
        return
      }
      if (this.snWxStorage.serialNo !== this.ysWxForm.serialNo) {
        this.ysStChangeStatus = 1
        this.ysMbChangeStatus = 1
        this.ysMbChangeStStatus = 1
        this.lockUseType = 1
        this.lockChangeUseType = 1
        this.skuIsLimited = 0
        this.lockList = []
        this.initYsWxSn(this.ysWxForm.serialNo)
      }
    },
    async initYsWxSn (sn) {
      try {
        const currentDeviceInfo = await this.checkEzvizSn(sn, 0, 0)
        this.currentDeviceInfo = JSON.parse(JSON.stringify(currentDeviceInfo))
        this.currentSnType = currentDeviceInfo.snType
        this.snWxStorage.serialNo = currentDeviceInfo.sn
        this.ysWxForm = {
          ...this.ysWxForm,
          workOrderNo: this.workOrderNo,
          targetNo: currentDeviceInfo.skuNo || '',
          serialNo: currentDeviceInfo.sn || '',
          lockBodyInfo: {
            currentLockBodyInfo: this.ysWxForm.lockBodyInfo.currentLockBodyInfo || {
              lockSkuNo: '',
              lockSkuName: '',
              lockSn: '',
              isEZLock: 0
            },
            replaceLockBodyInfo: this.ysWxForm.lockBodyInfo.replaceLockBodyInfo || {
              lockSkuNo: '',
              lockSkuName: '',
              lockSn: '',
              isEZLock: 0
            },
            replacePanelInfo: this.ysWxForm.lockBodyInfo.replacePanelInfo || {
              panelSkuNo: '',
              panelSkuName: '',
              panelSn: '',
              isEZLock: 0
            }
          }
        }

        if (this.currentDeviceInfo.validWarranty == 1) {
          this.ysWxForm.voucherType = 2
          this.showVoucherContentUpload = true
        } else {
          this.ysWxForm.voucherType = 1
          this.ysWxForm.voucherContent = ''
          this.showVoucherContentUpload = false
        }

        if (this.currentSnType == 4) {
          const { skuIsLimited } = await this.determineIsForceControl({
            workOrderNo: this.workOrderNo,
            sn: this.ysWxForm.serialNo,
            snType: 0,
            scenarioType: 2
          })
          this.skuIsLimited = skuIsLimited
          if (this.skuIsLimited == 0) {
            const { list } = await this.getPartsListInfo()
            this.lockList = list
          }
        }
      } catch (err) {
        this.ysWxForm = {
          ...this.ysWxForm,
          targetNo: '',
          serialNo: ''
        }
        this.currentSnType = ''
        this.snWxStorage.serialNo = ''
        this.$message.error(err)
      }
    },
    async handleChangeYsWxSnQr (scenarioType, needControl = false) {
      if (needControl) {
        const { skuIsLimited } = await this.determineIsForceControl({
          workOrderNo: this.workOrderNo,
          sn: this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn,
          snType: 0,
          scenarioType: 2
        })
        this.skuIsLimited = skuIsLimited
        if (this.skuIsLimited == 0) {
          const { list } = await this.getPartsListInfo()
          this.lockList = list
        }
      }

      switch (scenarioType) {
        case 1:
          if (!this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn) {
            this.$message.error('请输入SN码！')
            return
          }
          if (this.snWxStorage.panelSn !== this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn) {
            this.changeYsWxSnQr(this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn, scenarioType)
          }
          break
        case 2:
          if (!this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn) {
            this.$message.error('请输入SN码！')
            return
          }
          if (this.snWxStorage.panelSn !== this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn) {
            this.changeYsWxSnQr(this.ysWxForm.lockBodyInfo.replacePanelInfo.panelSn, scenarioType)
          }
          break
        case 3:
          if (!this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn) {
            this.$message.error('请输入SN码！')
            return
          }
          if (this.snWxStorage.replaceLockBodyInfoLockSn !== this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn) {
            const that = this
            this.$confirm({
              title: '提示！',
              content: '是否萤石锁体？',
              okText: '是',
              cancelText: '否',
              onOk () {
                that.changeYsWxSnQr(that.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn, scenarioType)
              },
              onCancel () {
                that.ysWxForm.lockBodyInfo.replaceLockBodyInfo = {
                  lockSkuNo: 'other_brand',
                  lockSkuName: '非萤石锁体',
                  lockSn: that.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn,
                  isEZLock: 0
                }
                that.snWxStorage.replaceLockBodyInfoLockSn = that.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn
              }
            })
          }
          break
      }
    },
    async changeYsWxSnQr (sn, scenarioType) {
      try {
        const data = await this.checkEzvizSn(sn, 1, scenarioType)
        if (scenarioType == 1 || scenarioType == 2) {
          this.ysWxForm.lockBodyInfo.replacePanelInfo = {
            panelSkuNo: data.skuNo,
            panelSkuName: data.name,
            panelSn: data.sn
          }
          this.snWxStorage.panelSn = data.sn
        } else if (scenarioType == 3) {
          this.ysWxForm.lockBodyInfo.replaceLockBodyInfo = {
            lockSkuNo: data.skuNo,
            lockSkuName: data.name,
            lockSn: data.sn,
            isEZLock: 1
          }
          this.snWxStorage.replaceLockBodyInfoLockSn = data.sn
        }
      } catch (err) {
        if (scenarioType == 1 || scenarioType == 2) {
          this.ysWxForm.lockBodyInfo.replacePanelInfo = {
            panelSkuNo: '',
            panelSkuName: '',
            panelSn: ''
          }
          this.snWxStorage.panelSn = ''
        } else {
          this.ysWxForm.lockBodyInfo.replaceLockBodyInfo = {
            lockSkuNo: '',
            lockSkuName: '',
            lockSn: '',
            isEZLock: 0
          }
          this.snWxStorage.replaceLockBodyInfoLockSn = ''
        }
        this.$message.error(err)
      }
    },
    lockUseTypeWxChange () {
      this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn = ''
      this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuNo = ''
      this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuName = ''
      this.ysWxForm.lockBodyInfo.currentLockBodyInfo.isEZLock = 0
      this.snWxStorage.currentLockBodyInfoLockSn = ''
    },
    handleYsLockWxSn () {
      if (!this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn) {
        this.$message.error('请输入SN码！')
        return
      }
      if (this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn !== this.snWxStorage.currentLockBodyInfoLockSn) {
        const that = this
        this.$confirm({
          title: '提示！',
          content: '是否萤石锁体？',
          okText: '是',
          cancelText: '否',
          onOk () {
            that.ysLockWxSn(that.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn)
          },
          onCancel () {
            that.ysWxForm.lockBodyInfo.currentLockBodyInfo = {
              lockSkuNo: 'other_brand',
              lockSkuName: '非萤石锁体',
              lockSn: that.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn,
              isEZLock: 0
            }
            that.snWxStorage.currentLockBodyInfoLockSn = that.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn
          }
        })
      }
    },
    async ysLockWxSn (sn) {
      try {
        const data = await this.checkEzvizSn(sn, 1, 3)
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo = {
          lockSkuNo: data.skuNo,
          lockSkuName: data.name,
          lockSn: data.sn,
          isEZLock: 1
        }
        this.snWxStorage.currentLockBodyInfoLockSn = data.sn
      } catch (err) {
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo = {
          lockSkuNo: '',
          lockSkuName: '',
          lockSn: '',
          isEZLock: 0
        }
        this.snWxStorage.currentLockBodyInfoLockSn = ''
        this.$message.error(err)
      }
    },
    handleLockWxSnChange (e) {
      const findLock = this.lockList.find(s => s.skuNo == e)
      if (findLock) {
        const that = this
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuName = findLock.skuName || ''
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSkuNo = findLock.skuNo || ''
        this.ysWxForm.lockBodyInfo.currentLockBodyInfo.lockSn = findLock.sn || ''
        this.snWxStorage.currentLockBodyInfoLockSn = ''
        this.$confirm({
          title: '提示！',
          content: '是否萤石锁体？',
          okText: '是',
          cancelText: '否',
          onOk () {
            that.ysWxForm.lockBodyInfo.currentLockBodyInfo.isEZLock = 1
          },
          onCancel () {
            that.ysWxForm.lockBodyInfo.currentLockBodyInfo.isEZLock = 0
          }
        })
      }
    },
    lockChangeUseTypeWxChange () {
      this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuName = ''
      this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo = ''
      this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn = ''
      this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.isEZLock = 0
      this.snWxStorage.replaceLockBodyInfoLockSn = null
    },
    handleWxLockReplaceSnChange (e) {
      const findLock = this.lockList.find(s => s.skuNo == e)
      if (findLock) {
        const that = this
        this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuName = findLock.skuName || ''
        this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSkuNo = findLock.skuNo || ''
        this.ysWxForm.lockBodyInfo.replaceLockBodyInfo.lockSn = findLock.sn || ''
        that.snWxStorage.replaceLockBodyInfoLockSn = ''
        this.$confirm({
          title: '提示！',
          content: '是否萤石锁体？',
          okText: '是',
          cancelText: '否',
          onOk () {
            that.ysWxForm.lockBodyInfo.replaceLockBodyInfo.isEZLock = 1
          },
          onCancel () {
            that.ysWxForm.lockBodyInfo.replaceLockBodyInfo.isEZLock = 0
          }
        })
      }
    },
    ysStWxChange () {
      this.ysWxForm.lockBodyInfo.replacePanelInfo = {
        panelSkuNo: '',
        panelSkuName: '',
        panelSn: ''
      }
      this.ysWxForm.lockBodyInfo.replaceLockBodyInfo = {
        lockSkuNo: '',
        lockSkuName: '',
        lockSn: '',
        isEZLock: 0
      }
      this.snWxStorage.replaceLockBodyInfoLockSn = null
      this.snWxStorage.panelSn = null
    },
    getYsSn () {
      return new Promise((resolve, reject) => {
        getYsSn({ orderId: this.orderId }).then(res => {
          if (res.data && res.data.length) {
            this.ysAzForm = {
              ...this.ysAzForm,
              ...res.data[0]
            }
                      console.log('555555555555555555555', res.data)
                      if(res.data[0].otherString){
          this.lockUseType=res.data[0].otherString.lockUseType
            }
                     
                      console.log(this.lockUseType)
            this.currentDeviceInfo = {
              name: res.data[0].skuName,
              model: res.data[0].model || '',
              snType: res.data[0].snType,
              sn: res.data[0].sn
            }
            this.currentSnType = res.data[0].snType
            this.snStorage = {
              sn: res.data[0].sn || null,
              replaceSn: res.data[0].replaceSn || null,
              lockSn: res.data[0].lockSn || null,
              lockReplaceSn: res.data[0].lockReplaceSn || null
            }
            this.ysMbChangeStatus = (res.data[0].snType == 4 && res.data[0].replaceSn && this.ysOrderType != 1) ? 2 : 1
            this.ysStChangeStatus = (res.data[0].snType == 1 && res.data[0].replaceSn && this.ysOrderType != 1) ? 2 : 1
            this.ysMbChangeStStatus = (res.data[0].snType == 4 && res.data[0].lockReplaceSn && this.ysOrderType != 1) ? 2 : 1
            // this.lockUseType = 1
            this.lockChangeUseType = 1
                          const skuNo = this.ysOrderType == 1 ? this.ysAzForm.skuNo : this.ysWxForm.targetNo
        getPartsListInfo({ skuNo }).then(res => {
          if (res.code == 0) {
     this.lockList = res.data.list
            console.log("lockList", this.lockList)
          }
        }).catch(err => { reject(err) })
        
          }
          resolve()
        }).catch(err => { reject(err) })
      })
    },
    handleInitYsSn () {
      if (this.snStorage.sn !== this.ysAzForm.sn) {
        this.initYsSn(this.ysAzForm.sn)
      }
    },
    async initYsSn (sn) {
      try {
        const data = await this.checkEzvizSn(sn, 0, 0)
        this.currentDeviceInfo = JSON.parse(JSON.stringify(data))
        this.currentSnType = data.snType
        this.snStorage.sn = data.sn
        this.ysAzForm = {
          sn: data.sn,
          skuNo: data.skuNo,
          skuName: data.name,
          replaceSn: '',
          replaceSkuNo: '',
          replaceSkuName: '',
          lockSn: '',
          lockSkuNo: '',
          lockSkuName: '',
          lockReplaceSn: '',
          lockReplaceSkuNo: '',
          lockReplaceSkuName: '',
          lockStatus: '1',
          status: '1',
          snType: data.snType
        }
        if (this.currentSnType == 4) {
          const { skuIsLimited } = await this.determineIsForceControl({
            workOrderNo: this.workOrderNo,
            sn: this.ysAzForm.sn,
            snType: 0,
            scenarioType: 2
          })
          this.skuIsLimited = skuIsLimited
          if (this.skuIsLimited == 0) {
            const { list } = await this.getPartsListInfo()
            this.lockList = list
          }
        }
      } catch (err) {
        this.ysAzForm = {
          ...this.ysAzForm,
          sn: '',
          skuNo: '',
          skuName: '',
          snType: '',
          status: '',
          lockStatus: ''
        }
        this.currentSnType = ''
        this.snStorage.sn = ''
        this.$message.error(err)
      }
    },
    handleLockSnChange (e) {
      const findLock = this.lockList.find(s => s.skuNo == e)
      if (findLock) {
        this.ysAzForm.lockSkuName = findLock.skuName || ''
        this.ysAzForm.lockSkuNo = findLock.skuNo || ''
        this.ysAzForm.lockSn = findLock.sn || ''
      }
    },
    handleYsLockSn () {
      if (this.snStorage.lockSn !== this.ysAzForm.lockSn) {
        this.ysLockSn(this.ysAzForm.lockSn)
      }
    },
    async ysLockSn (sn) {
      try {
        const data = await this.checkEzvizSn(sn, 0, 3)
        this.ysAzForm = {
          ...this.ysAzForm,
          lockSn: data.sn,
          lockSkuNo: data.skuNo,
          lockSkuName: data.name
        }
        this.snStorage.lockSn = data.sn
      } catch (err) {
        this.ysAzForm = {
          ...this.ysAzForm,
          lockSn: '',
          lockSkuNo: '',
          lockSkuName: ''
        }
        this.snStorage.lockSn = ''
        this.$message.error(err)
      }
    },
    lockUseTypeChange () {
      this.ysAzForm.lockSn = ''
      this.ysAzForm.lockSkuNo = ''
      this.ysAzForm.lockSkuName = ''
      this.snStorage.lockSn = ''
    },
    handlePreview (file) {
      this.$emit('preview', file)
    }
  }
}
</script>

<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 22px;

  .form-item-v {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.form-label {
  width: 200px;
  margin-right: 15px;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  &.required {
    &::before {
      content: '*';
      color: red;
      margin-right: 4px;
    }
  }
}

.form-tips {
  color: brown;
  margin-left: 10px;
}

.form-value {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.ant-radio-group {
  display: flex;
  align-items: center;
}

.ant-radio-wrapper {
  margin-right: 24px;
}
</style>
